import { createActionTypeModel } from "../../../../store/global/action-model";
// Type Container for ContractsRoyalty Action/Mutation Types. Use it in   contracts/actions.js, contracts/mutations.js and the Vuex Host Component
export const ContractsRoyaltyData = createActionTypeModel(
  "ContractsRoyaltyData"
);
export const ContractsList = createActionTypeModel("ContractsList");
export const ContractsDetails = createActionTypeModel("ContractsDetails");
export const ContractsFlagDetails = createActionTypeModel("ContractsFlagDetails");
export const ContractTabDelete = createActionTypeModel("ContractTabDelete");
export const ContractItems = createActionTypeModel("ContractItems");
export const ContractRelease = createActionTypeModel("ContractRelease");
export const ContractProduct = createActionTypeModel("ContractProduct");
export const ContractTrack = createActionTypeModel("ContractTrack");
export const AutoFillTrack = createActionTypeModel("AutoFillTrack");
export const AutoFillRelease = createActionTypeModel("AutoFillRelease");
export const ContractDeductions = createActionTypeModel("ContractDeductions");
export const ContractRoyaltyRates = createActionTypeModel(
  "ContractRoyaltyRates"
);
export const ContractRoyaltyRatesReserve = createActionTypeModel(
  "ContractRoyaltyRatesReserve"
);
export const ContractRoyaltyScale = createActionTypeModel(
  "ContractRoyaltyScale"
);
export const TurnoverScale = createActionTypeModel("TurnoverScale");
export const ContractMC = createActionTypeModel("ContractMC");
export const ContractLicencingNr = createActionTypeModel("ContractLicencingNr");
export const RoyaltyCostGroups = createActionTypeModel("RoyaltyCostGroups"); // royalty_cost_groups
export const ContractlReserveSettings = createActionTypeModel(
  "ContractlReserveSettings"
); // l_reserve_settings
export const RecoupableContractBalances = createActionTypeModel(
  "RecoupableContractBalances"
); // l_balances
export const ContractBalance = createActionTypeModel("ContractBalance");
export const ContractSpecials = createActionTypeModel("ContractSpecials");
export const SET_CONTRACT_PRODUCT_FILES = "SET_CONTRACT_PRODUCT_FILES";
